var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-layout',[_c('page-navigation',{attrs:{"pages":_vm.pages}}),_c('router-view',{key:_vm.$route.path})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }